/**
 * جلوگیری از درخواست‌های کند به gravatar در لیست/کانبان.
 * تصاویر روی سرور خود (user-uploads و ...) همچنان نمایش داده می‌شوند.
 */
export const isGravatarUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  return /gravatar\.com/i.test(url.trim());
};

/**
 * @param {string|undefined|null} imageUrl
 * @returns {string|undefined} — undefined یعنی از آیکون/حرف اول Avatar استفاده شود
 */
export const resolveAvatarSrc = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== 'string') return undefined;
  const trimmed = imageUrl.trim();
  if (!trimmed || isGravatarUrl(trimmed)) return undefined;
  return trimmed;
};
